<!-- Main Container -->
<div class="p-6 bg-gray-50 min-h-screen">
  
  <div *ngIf="successMessage" class="mb-4 p-4 bg-green-100 text-green-800 border border-green-200 rounded-lg shadow-sm font-medium flex items-center justify-between transition-all duration-300">
    <span>{{ successMessage }}</span>
    <button (click)="successMessage = ''" class="hover:text-green-900 focus:outline-none">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
    </button>
  </div>
  
  <div *ngIf="errorMessage" class="mb-4 p-4 bg-red-100 text-red-800 border border-red-200 rounded-lg shadow-sm font-medium flex items-center justify-between transition-all duration-300">
    <span>{{ errorMessage }}</span>
    <button (click)="errorMessage = ''" class="hover:text-red-900 focus:outline-none">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
    </button>
  </div>

  <!-- Header -->
  <div class="flex justify-between items-center mb-8">
    <h1 class="text-2xl font-semibold text-gray-900">{{ t('studyBet.title') }}</h1>
    <button (click)="openCreateModal()"
      class="flex items-center gap-2 px-4 py-2 text-white rounded-lg font-medium hover:opacity-90 transition-opacity"
      style="background-color: #FF5C01;" [disabled]="isLoading">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
      </svg>
      {{ t('studyBet.newStudy') }}
    </button>
  </div>

  <!-- Search Bar -->
  <div class="mb-6">
    <div class="relative">
      <svg class="absolute left-3 top-3 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
      </svg>
      <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" [placeholder]="t('studyBet.searchPlaceholder')"
        class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
    <span class="ml-2 text-gray-600">{{ t('studyBet.loading') }}</span>
  </div>

  <!-- Table -->
  <div *ngIf="!isLoading" class="bg-white rounded-lg shadow overflow-hidden">
    <table class="w-full">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{
            t('studyBet.table.title') }}</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{
            t('studyBet.table.description') }}</th>
          <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{
            t('studyBet.table.betName') }}</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{
            t('studyBet.table.creationDate') }}</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{
            t('studyBet.table.status') }}</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{
            t('studyBet.table.actions') }}</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr *ngFor="let etude of filteredEtudes" class="hover:bg-gray-50">
          <!-- Titre tréronqué avec tooltip -->
          <td class="px-6 py-4" style="max-width: 200px;">
            <div class="text-sm font-semibold text-gray-900 truncate" [title]="etude.titre">{{ etude.titre }}</div>
          </td>
          <!-- Description 2 lignes max -->
          <td class="px-6 py-4" style="max-width: 260px;">
            <div class="text-sm text-gray-700 overflow-hidden" style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; line-clamp: 2;">{{ etude.description }}</div>
          </td>
          <!-- Badge studyType -->
          <td class="px-4 py-4 whitespace-nowrap">
            <span [class]="'inline-flex px-2 py-0.5 text-xs font-medium rounded-full ' + getStudyTypeBadgeClass(etude.studyType)">
              {{ getStudyTypeLabel(etude.studyType) }}
            </span>
          </td>
          <!-- Nom BET -->
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm text-gray-900">{{ etude.nomBET }}</div>
          </td>
          <!-- Date création -->
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm text-gray-900">{{ etude.dateCreation }}</div>
          </td>
          <!-- Statut -->
          <td class="px-6 py-4 whitespace-nowrap overflow-visible relative">
            <div class="relative inline-block">
              <button
                (click)="toggleEtudeStatusDropdown(etude.id, $event)"
                [class]="'inline-flex items-center gap-1 px-2 py-1 text-xs font-semibold rounded-full cursor-pointer hover:opacity-80 transition-all ' + getStatusClass(etude.statut)">
                {{ etude.statut }}
                <svg class="w-3 h-3 flex-shrink-0" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>

              <div *ngIf="showEtudeStatusDropdown === etude.id"
                class="absolute z-[100] mt-1 w-36 bg-white rounded-md shadow-lg border border-gray-200 left-0">
                <div class="py-1">
                  <button
                    *ngFor="let s of availableEtudeStatuses"
                    (click)="changeEtudeStatus(etude.id, s.value, $event)"
                    class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors">
                    {{ s.label }}
                  </button>
                </div>
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
            <div class="flex items-center gap-2">
              <!-- Voir détails -->
              <button (click)="openDetailModal(etude)" class="text-gray-600 hover:text-gray-900" title="Voir les détails">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7"></path>
                </svg>
              </button>

              <!-- Rapport IA -->
              <button (click)="openIAModal(etude)" class="text-purple-600 hover:text-purple-900" title="Voir rapport IA">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                </svg>
              </button>

              <!-- Modifier -->
              <button *ngIf="canEdit(etude.statut)" (click)="openEditModal(etude)" class="text-blue-600 hover:text-blue-900" title="Modifier">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                </svg>
              </button>

              <!-- Supprimer -->
              <button (click)="deleteEtude(etude)" class="text-red-600 hover:text-red-900" title="Supprimer">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Empty state -->
    <div *ngIf="filteredEtudes.length === 0 && !isLoading" class="text-center py-12">
      <p class="text-gray-500">{{ t('studyBet.noStudy') }}</p>
    </div>
  </div>

  <!-- Pagination -->
  <div *ngIf="!isLoading && totalPages > 1" class="flex items-center justify-between mt-6 px-4">
    <div class="flex items-center text-sm text-gray-700">
      <span>{{ t('studyBet.pagination.showing') }} {{ currentPage * pageSize + 1 }} {{ t('studyBet.pagination.to') }} {{
        Math.min((currentPage + 1) * pageSize, totalElements) }}
        {{ t('studyBet.pagination.of') }} {{ totalElements }} {{ t('studyBet.pagination.results') }}</span>
    </div>

    <div class="flex items-center space-x-2">
      <!-- Previous button -->
      <button (click)="previousPage()" [disabled]="currentPage === 0"
        class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
        {{ t('studyBet.pagination.previous') }}
      </button>

      <!-- Page numbers -->
      <div class="flex space-x-1">
        <button *ngFor="let page of getPageNumbers()" (click)="goToPage(page)" [class]="'px-3 py-2 text-sm font-medium border rounded-md ' + 
                  (page === currentPage ? 
                    'bg-orange-500 text-white border-orange-500' : 
                    'text-gray-700 bg-white border-gray-300 hover:bg-gray-50')">
          {{ page + 1 }}
        </button>
      </div>

      <!-- Next button -->
      <button (click)="nextPage()" [disabled]="currentPage === totalPages - 1"
        class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
        {{ t('studyBet.pagination.next') }}
      </button>
    </div>
  </div>
</div>

<!-- Create Modal -->
<div *ngIf="showCreateModal" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen px-4">
    <div class="fixed inset-0 bg-black opacity-50" (click)="closeAllModals()"></div>
    <div class="bg-white rounded-lg p-8 max-w-2xl w-full relative z-10">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-semibold">{{ t('studyBet.modal.newStudy') }}</h2>
        <button (click)="closeAllModals()" class="text-gray-400 hover:text-gray-600">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Modal de création étendu avec max-w-2xl -->
      <div class="space-y-4 max-h-[70vh] overflow-y-auto pr-1">

        <!-- Sélection BET -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('studyBet.modal.selectBET') }} <span class="text-red-500">*</span></label>
          <div class="relative">
            <input type="text" [(ngModel)]="betSearchKeyword" (input)="onBETSearchChange()" (focus)="focusBETInput()"
              placeholder="Rechercher un BET..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500">
            <div *ngIf="showBetDropdown && (availableBETs.length > 0 || betLoading)"
              class="absolute z-20 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-52 overflow-y-auto"
              (scroll)="onBETScroll($event)">
              <div *ngFor="let bet of availableBETs" (click)="selectBET(bet)" class="px-3 py-2 hover:bg-orange-50 cursor-pointer">
                <div class="font-medium text-sm">{{ bet.prenom }} {{ bet.nom }}</div>
                <div class="text-xs text-gray-500">{{ bet.email }}</div>
              </div>
              <div *ngIf="betLoading" class="px-3 py-2 text-center"><div class="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-500 mx-auto"></div></div>
              <div *ngIf="!betLoading && availableBETs.length === 0" class="px-3 py-2 text-center text-sm text-gray-500">Aucun BET trouvé</div>
            </div>
          </div>
        </div>

        <!-- Titre -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('studyBet.modal.titleLabel') }} <span class="text-red-500">*</span></label>
          <input type="text" [(ngModel)]="newEtude.title" [placeholder]="t('studyBet.modal.enterPlaceholder')"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500">
        </div>

        <!-- Type d'étude -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Type d'étude <span class="text-red-500">*</span></label>
          <select [(ngModel)]="newEtude.studyType" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white">
            <option value="">-- Sélectionner un type --</option>
            <option *ngFor="let t of studyTypes" [value]="t.value">{{ t.label }}</option>
          </select>
        </div>

        <!-- Description -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('studyBet.modal.descriptionLabel') }} <span class="text-red-500">*</span></label>
          <textarea [(ngModel)]="newEtude.description" [placeholder]="t('studyBet.modal.enterPlaceholder')" rows="3"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"></textarea>
        </div>

        <!-- Objectif -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Objectif <span class="text-red-500">*</span></label>
          <textarea [(ngModel)]="newEtude.objective" placeholder="Décrivez l'objectif de l'étude..." rows="2"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"></textarea>
        </div>

        <!-- Problème observé -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Problème observé <span class="text-red-500">*</span></label>
          <textarea [(ngModel)]="newEtude.problemObserved" placeholder="Décrivez le problème constaté..." rows="2"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"></textarea>
        </div>

        <!-- Section documents dynamiques -->
        <div>
          <div class="flex items-center justify-between mb-2">
            <label class="block text-sm font-medium text-gray-700">Documents joints</label>
            <button type="button" (click)="addDocumentEntry()"
              class="flex items-center gap-1 text-sm text-orange-600 hover:text-orange-700 font-medium">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>
              Ajouter un document
            </button>
          </div>

          <div *ngFor="let entry of documentEntries; let i = index" class="flex items-center gap-2 mb-2 p-2 bg-gray-50 rounded-lg border border-gray-200">
            <!-- Type de document -->
            <select [(ngModel)]="entry.type" (ngModelChange)="onDocumentTypeChange(i, $event)"
              class="flex-1 px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 bg-white">
              <option value="">-- Type --</option>
              <option *ngFor="let dt of documentTypes" [value]="dt.value">{{ dt.label }}</option>
            </select>

            <!-- Fichier -->
            <div class="flex-1">
              <label [for]="'docFile_' + i" class="flex items-center gap-1 px-2 py-1.5 text-sm bg-white border border-gray-300 rounded-md cursor-pointer hover:bg-orange-50 truncate">
                <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"/></svg>
                <span class="truncate text-gray-600">{{ entry.fileName || 'Choisir...' }}</span>
              </label>
              <input [id]="'docFile_' + i" type="file" class="hidden" (change)="onDocumentFileChange(i, $event)">
            </div>

            <!-- Supprimer -->
            <button type="button" (click)="removeDocumentEntry(i)" class="p-1.5 text-red-500 hover:bg-red-50 rounded-md flex-shrink-0">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
            </button>
          </div>

          <p *ngIf="documentEntries.length === 0" class="text-xs text-gray-400 italic">Aucun document ajouté. Cliquez sur "Ajouter un document" pour en joindre.</p>
        </div>
      </div>

      <div class="flex gap-3 mt-6">
        <button (click)="createEtude()"
          [disabled]="isLoading || !newEtude.title || !newEtude.description || !newEtude.studyType || !newEtude.objective || !newEtude.problemObserved || !newEtude.betId"
          class="flex-1 px-4 py-2 text-white rounded-lg font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
          style="background-color: #FF5C01;">
          <span *ngIf="!isLoading">{{ t('common.send') }}</span>
          <span *ngIf="isLoading" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            {{ t('studyBet.modal.sending') }}
          </span>
        </button>
        <button (click)="closeAllModals()" [disabled]="isLoading"
          class="flex-1 px-4 py-2 text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 disabled:opacity-50">
          {{ t('common.cancel') }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Modal -->
<div *ngIf="showEditModal" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen px-4">
    <div class="fixed inset-0 bg-black opacity-50" (click)="closeAllModals()"></div>
    <div class="bg-white rounded-lg p-8 max-w-md w-full relative z-10">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-semibold">{{ t('studyBet.modal.editStudy') }}</h2>
        <button (click)="closeAllModals()" class="text-gray-400 hover:text-gray-600">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="space-y-4">

        <!-- Champ auto-complétion BET (même logique que création) -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('studyBet.modal.selectBET') }}</label>
          <div class="relative">

            <!-- BET actuellement sélectionné -->
            <div *ngIf="editSelectedBET" class="mb-2 flex items-center gap-2 px-3 py-2 bg-orange-50 border border-orange-200 rounded-md">
              <div class="flex-1 text-sm font-medium text-gray-800">
                {{ editSelectedBET.prenom }} {{ editSelectedBET.nom }}
              </div>
              <button type="button" (click)="clearEditBET()" class="text-gray-400 hover:text-red-500 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>

            <input
              type="text"
              [(ngModel)]="editBetSearchKeyword"
              (input)="onEditBETSearchChange()"
              (focus)="focusEditBETInput()"
              placeholder="Rechercher un BET..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">

            <!-- Dropdown avec scroll infini -->
            <div
              *ngIf="showEditBetDropdown && (availableBETs.length > 0 || betLoading)"
              class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto"
              (scroll)="onBETScroll($event)">

              <div
                *ngFor="let bet of availableBETs"
                (click)="selectEditBET(bet)"
                class="px-3 py-2 hover:bg-gray-100 cursor-pointer transition-colors">
                <div class="font-medium text-sm">{{ bet.prenom }} {{ bet.nom }}</div>
                <div class="text-xs text-gray-500">{{ bet.email }}</div>
              </div>

              <!-- Loading -->
              <div *ngIf="betLoading" class="px-3 py-2 text-center text-sm text-gray-500">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-500 mx-auto"></div>
              </div>

              <!-- Aucun résultat -->
              <div *ngIf="!betLoading && availableBETs.length === 0"
                class="px-3 py-2 text-center text-sm text-gray-500">
                Aucun BET trouvé
              </div>
            </div>

          </div>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('studyBet.modal.titleLabel') }} <span class="text-red-500">*</span></label>
          <input type="text" [(ngModel)]="editEtude.title" [placeholder]="t('studyBet.modal.enterPlaceholder')"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500">
        </div>

        <!-- Type d'étude -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('studyBet.modal.studyType') || "Type d'étude" }} <span class="text-red-500">*</span></label>
          <select [(ngModel)]="editEtude.studyType" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white">
            <option value="">-- {{ t('studyBet.modal.selectType') || "Sélectionner un type" }} --</option>
            <option *ngFor="let t of studyTypes" [value]="t.value">{{ t.label }}</option>
          </select>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('studyBet.modal.descriptionLabel') }} <span class="text-red-500">*</span></label>
          <textarea [(ngModel)]="editEtude.description" [placeholder]="t('studyBet.modal.enterPlaceholder')" rows="3"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"></textarea>
        </div>

        <!-- Objectif -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('studyBet.modal.objective') }} <span class="text-red-500">*</span></label>
          <textarea [(ngModel)]="editEtude.objective" [placeholder]="t('studyBet.modal.objectivePlaceholder')" rows="2"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"></textarea>
        </div>

        <!-- Problème observé -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('studyBet.modal.problemObserved') }} <span class="text-red-500">*</span></label>
          <textarea [(ngModel)]="editEtude.problemObserved" [placeholder]="t('studyBet.modal.problemObservedPlaceholder')" rows="2"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"></textarea>
        </div>

        <!-- Section documents dynamiques -->
        <div>
          <div class="flex items-center justify-between mb-2">
            <label class="block text-sm font-medium text-gray-700">{{ t('studyBet.modal.attachedDocuments') || "Documents joints" }}</label>
            <button type="button" (click)="addDocumentEntry()"
              class="flex items-center gap-1 text-sm text-orange-600 hover:text-orange-700 font-medium">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>
              {{ t('studyBet.modal.addDocument') || "Ajouter un document" }}
            </button>
          </div>

          <div *ngFor="let entry of documentEntries; let i = index" class="flex items-center gap-2 mb-2 p-2 bg-gray-50 rounded-lg border border-gray-200">
            <!-- Type de document -->
            <select [(ngModel)]="entry.type" (ngModelChange)="onDocumentTypeChange(i, $event)"
              class="flex-1 px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 bg-white">
              <option value="">-- {{ t('studyBet.modal.type') || "Type" }} --</option>
              <option *ngFor="let dt of documentTypes" [value]="dt.value">{{ dt.label }}</option>
            </select>

            <!-- Fichier -->
            <div class="flex-1">
              <label [for]="'editDocFile_' + i" class="flex items-center gap-1 px-2 py-1.5 text-sm bg-white border border-gray-300 rounded-md cursor-pointer hover:bg-orange-50 truncate">
                <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"/></svg>
                <span class="truncate text-gray-600">{{ entry.fileName || t('common.chooseFile') }}</span>
              </label>
              <input [id]="'editDocFile_' + i" type="file" class="hidden" (change)="onDocumentFileChange(i, $event)">
            </div>

            <!-- Supprimer -->
            <button type="button" (click)="removeDocumentEntry(i)" class="p-1.5 text-red-500 hover:bg-red-50 rounded-md flex-shrink-0">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
            </button>
          </div>

          <p *ngIf="documentEntries.length === 0" class="text-xs text-gray-400 italic">{{ t('studyBet.modal.noDocumentAdded') || "Aucun document ajouté. Cliquez sur Ajouter un document pour en joindre." }}</p>
        </div>
      </div>

      <div class="flex gap-3 mt-8">
        <button (click)="updateEtude()"
          [disabled]="isLoading || !editEtude.title || !editEtude.description || !editEtude.studyType || !editEtude.objective || !editEtude.problemObserved || !editEtude.betId"
          class="flex-1 px-4 py-2 text-white rounded-lg font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
          style="background-color: #FF5C01;">
          <span *ngIf="!isLoading">{{ t('common.send') }}</span>
          <span *ngIf="isLoading" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            {{ t('studyBet.modal.sending') }}
          </span>
        </button>
        <button (click)="closeAllModals()" [disabled]="isLoading"
          class="flex-1 px-4 py-2 text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 disabled:opacity-50">
          {{ t('common.cancel') }}
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Detail Modal -->
<div *ngIf="showDetailModal && selectedEtude" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen px-4">
    <div class="fixed inset-0 bg-black bg-opacity-50" (click)="closeAllModals()"></div>

    <!-- Modal Container - 1100px width -->
    <div class="bg-white rounded-2xl w-full relative z-10 max-h-[90vh] overflow-y-auto" style="max-width: 1100px;">

      <!-- Header - 74px height -->
      <div class="flex justify-between items-center px-8 py-6 border-b" style="border-color: #F7FAFC; height: 74px;">
        <h2 class="text-xl font-semibold text-gray-900">{{ selectedEtude.titre }}</h2>
        <button (click)="closeAllModals()" class="text-gray-400 hover:text-gray-600 transition-colors">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Progress Bar Section - 98px height -->
      <div class="px-8 py-5 border-b" style="border-color: #F7FAFC; height: 98px;">
        <div class="flex items-center justify-between relative">
          <ng-container *ngFor="let step of getProgressSteps(selectedEtude.statut); let i = index; let last = last">
            <!-- Circle -->
            <div [class]="'w-10 h-10 rounded-full flex items-center justify-center font-semibold z-10 transition-all duration-300 ' + 
                      (step.showCheck ? 'text-white' : 
                       step.isCurrent ? 'border-2 text-xs bg-white' : 
                       'border-2 text-xs bg-white')" [style.background-color]="step.showCheck ? '#FF5C02' : ''"
              [style.border-color]="step.isCurrent ? '#FF5C02' : '#E2E8F0'"
              [style.color]="step.isCurrent && !step.showCheck ? '#FF5C02' : (step.showCheck ? 'white' : '#CBD5E0')">
              <svg *ngIf="step.showCheck" class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M9.07825 15.642L18.7202 6L20.0005 7.28025L9.07825 18.2025L4 13.1257L5.28025 11.8455L9.07825 15.642Z" />
              </svg>
              <span *ngIf="!step.showCheck">{{ step.step }}</span>
            </div>

            <!-- Line - 254.67px width -->
            <div *ngIf="!last" class="h-0.5 transition-all duration-300" [style.width.px]="254.67"
              [style.background-color]="step.isCompleted ? '#FF5C02' : '#E2E8F0'">
            </div>
          </ng-container>
        </div>

        <!-- Labels -->
        <div class="flex justify-between mt-3">
          <div *ngFor="let step of getProgressSteps(selectedEtude.statut)" class="text-center" style="width: 25%;">
            <span class="text-xs font-semibold"
              [style.color]="step.isCurrent ? '#FF5C02' : (step.isCompleted ? '#1A202C' : '#A0AEC0')">
              {{ step.label }}
            </span>
          </div>
        </div>
      </div>

      <!-- Content Section -->
      <div class="p-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">

          <!-- Left Column - Information & Reports -->
          <div class="space-y-5">

            <!-- Card Informations - 278px height with border -->
            <div class="border rounded-lg p-5" style="border-color: #EAEFF6;">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">{{ t('studyBet.details.information') }}</h3>
              <div class="space-y-3">
                <div class="flex justify-between items-center">
                  <span class="text-sm text-gray-600">{{ t('studyBet.modal.titleLabel') }}</span>
                  <span class="text-sm font-medium text-gray-900">{{ selectedEtude.titre }}</span>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-sm text-gray-600">{{ t('studyBet.details.concernedBET') }}</span>
                  <span class="text-sm font-medium text-gray-900">{{ selectedEtude.nomBET }}</span>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-sm text-gray-600">{{ t('studyBet.details.creationDate') }}</span>
                  <span class="text-sm font-medium text-gray-900">{{ selectedEtude.dateCreation }}</span>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-sm text-gray-600">{{ t('studyBet.details.state') }}</span>
                  <span
                    [class]="'inline-flex px-2 py-1 text-xs font-semibold rounded-full ' + getStatusClass(selectedEtude.statut)">
                    {{ selectedEtude.statut }}
                  </span>
                </div>
              </div>

              <div class="mt-4 p-4 bg-gray-50 rounded-lg">
                <p class="text-sm text-gray-700 leading-relaxed">{{ selectedEtude.description }}</p>
              </div>
            </div>

            <!-- Card Rapports associés -->
            <div class="border rounded-lg p-5" style="border-color: #EAEFF6;">
              <h4 class="text-md font-semibold text-gray-900 mb-4">{{ t('studyBet.details.associatedReports') }}</h4>
              <button *ngIf="selectedEtude.statut === 'En attente'" (click)="openCreateReportModal()"
                class="p-1.5 text-orange-500 hover:bg-orange-50 rounded-md transition-colors group"
                title="Ajouter un rapport">
                <svg class="w-5 h-5 transition-transform group-hover:scale-110" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6">
                  </path>
                </svg>
              </button>

              <div *ngIf="selectedEtude.rapports && selectedEtude.rapports!.length > 0" class="space-y-3">
                <div *ngFor="let rapport of selectedEtude.rapports"
                  class="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div class="flex items-center gap-3">
                    <div class="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <svg class="w-5 h-5 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                          d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                          clip-rule="evenodd"></path>
                      </svg>
                    </div>
                    <div>
                      <p class="font-medium text-sm text-gray-900">{{ rapport.nom }}</p>
                      <p class="text-xs text-gray-500">{{ t('studyBet.details.reportSubmitted') }} {{
                        rapport.dateSubmission }} • {{ rapport.taille }}</p>
                    </div>
                  </div>
                  <button (click)="downloadReport(rapport)" class="text-blue-600 hover:text-blue-800 transition-colors"
                    title="Télécharger">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                      </path>
                    </svg>
                  </button>
                </div>
              </div>

              <div *ngIf="!selectedEtude.rapports || selectedEtude.rapports!.length === 0"
                class="text-center py-8 text-gray-500 italic text-sm">
                {{ t('studyBet.details.noReports') }}
              </div>
            </div>
          </div>

          <!-- Right Column - Comments -->
          <div class="flex flex-col h-full">
            <h3 class="text-lg font-semibold text-gray-900 mb-4">{{ t('studyBet.details.comments') }}</h3>

            <!-- Liste des commentaires avec scroll -->
            <div class="flex-1 mb-4 overflow-y-auto" style="max-height: 400px;">
              <div *ngIf="comments.length > 0; else noComments" class="space-y-3">
                <div *ngFor="let comment of comments" class="bg-gray-50 p-4 rounded-lg">
                  <div class="flex justify-between items-start mb-2">
                    <span class="font-semibold text-sm text-gray-900">{{ comment.authorName }}</span>
                    <span class="text-xs text-gray-500">{{ formatCommentDate(comment.createdAt) }}</span>
                  </div>
                  <p class="text-sm text-gray-700 leading-relaxed">{{ comment.content }}</p>
                </div>
              </div>

              <ng-template #noComments>
                <div class="text-center py-12 text-gray-500 italic text-sm">
                  {{ t('studyBet.details.noComments') }}
                </div>
              </ng-template>
            </div>

            <!-- Formulaire d'ajout de commentaire - Fixed at bottom -->
            <!-- <div class="mt-auto">
              <div class="flex gap-2">
              <input 
                #commentInput
                type="text" 
                placeholder="Ajouter un commentaire......"
                class="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                (keyup.enter)="addCommentDetail(commentInput.value); commentInput.value=''">
              <button 
                (click)="addCommentDetail(commentInput.value); commentInput.value=''"
                class="px-6 py-2 text-white rounded-lg font-medium hover:opacity-90"
                style="background-color: #FF5C01;"
                [disabled]="!commentInput.value.trim()">
                Envoyer
              </button>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Footer - Action Buttons -->
      <div class="flex justify-between items-center px-8 py-5 border-t" style="border-color: #F7FAFC;">
        <button (click)="closeAllModals()" class="text-gray-600 hover:text-gray-900 font-medium transition-colors">
          {{ t('studyBet.details.close') }}
        </button>

        <div class="flex gap-3" *ngIf="canValidateOrReject(selectedEtude.statut)">
          <button (click)="openValidateModal(selectedEtude)" class="px-8 rounded-lg font-medium transition-colors"
            style="height: 47px; background-color: #1C3055; color: white;" [style.hover]="'background-color: #152544'">
            {{ t('common.validate') }}
          </button>
          <button (click)="openRejectModal(selectedEtude)" class="px-8 rounded-lg font-medium transition-colors"
            style="height: 47px; border: 1px solid #F44336; color: #F44336; background-color: white;"
            onmouseover="this.style.backgroundColor='#FFEBEE'" onmouseout="this.style.backgroundColor='white'">
            {{ t('common.reject') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Validate Modal -->
<div *ngIf="showValidateModal && selectedEtude" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen px-4">
    <div class="fixed inset-0 bg-black opacity-50" (click)="closeAllModals()"></div>
    <div class="bg-white rounded-lg p-8 max-w-md w-full relative z-10">
      <div class="text-center">
        <div class="w-16 h-16 mx-auto mb-4 bg-orange-100 rounded-full flex items-center justify-center">
          <svg class="w-8 h-8 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd"></path>
          </svg>
        </div>

        <h3 class="text-lg font-semibold mb-2">{{ t('studyBet.modal.validateQuestion') }}</h3>
        <p class="text-gray-600 mb-6">{{ t('studyBet.modal.validateMessage') }}</p>

        <div class="flex gap-3">
          <button (click)="validateEtude()"
            class="flex-1 px-4 py-2 bg-blue-900 text-white rounded-lg font-medium hover:bg-blue-800">
            {{ t('common.validate') }}
          </button>
          <button (click)="closeAllModals()"
            class="flex-1 px-4 py-2 text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50">
            {{ t('common.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Reject Modal -->
<div *ngIf="showRejectModal && selectedEtude" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen px-4">
    <div class="fixed inset-0 bg-black opacity-50" (click)="closeAllModals()"></div>
    <div class="bg-white rounded-lg p-8 max-w-md w-full relative z-10">
      <div class="text-center">
        <div class="w-16 h-16 mx-auto mb-4 bg-orange-100 rounded-full flex items-center justify-center">
          <svg class="w-8 h-8 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd"></path>
          </svg>
        </div>

        <h3 class="text-lg font-semibold mb-2">{{ t('studyBet.modal.rejectQuestion') }}</h3>
        <p class="text-gray-600 mb-4">{{ t('studyBet.modal.rejectMessage') }}</p>
        <p class="text-gray-600 mb-6">{{ t('studyBet.modal.rejectReasonPrompt') }}</p>

        <textarea [(ngModel)]="rejectReason" [placeholder]="t('studyBet.modal.rejectReasonPlaceholder')" rows="3"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none mb-6"></textarea>

        <div class="flex gap-3">
          <button (click)="rejectEtude()" class="flex-1 px-4 py-2 text-white rounded-lg font-medium hover:opacity-90"
            style="background-color: #FF5C01;">
            {{ t('common.refuse') }}
          </button>
          <button (click)="closeAllModals()"
            class="flex-1 px-4 py-2 text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50">
            {{ t('common.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal de création de rapport -->
<div *ngIf="showCreateReportModal" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen px-4">
    <div class="fixed inset-0 bg-black bg-opacity-50" (click)="closeCreateReportModal()"></div>

    <div class="bg-white rounded-lg p-8 max-w-lg w-full relative z-10">
      <!-- Header -->
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-semibold text-gray-900">{{ t('studyBet.modal.newReport') }}</h2>
        <button (click)="closeCreateReportModal()" [disabled]="isCreatingReport"
          class="text-gray-400 hover:text-gray-600 transition-colors disabled:cursor-not-allowed">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Formulaire -->
      <div class="space-y-4">
        <!-- Champ Titre -->
        <div>
          <label for="reportTitle" class="block text-sm font-medium text-gray-700 mb-2">
            {{ t('studyBet.modal.titleLabel') }} <span class="text-red-500">*</span>
          </label>
          <input type="text" id="reportTitle" [(ngModel)]="newReport.title" placeholder="Ex: Rapport technique"
            [disabled]="isCreatingReport"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed">
        </div>

        <!-- Champ Version -->
        <div>
          <label for="reportVersion" class="block text-sm font-medium text-gray-700 mb-2">
            {{ t('studyBet.modal.versionLabel') }} <span class="text-red-500">*</span>
          </label>
          <input type="text" id="reportVersion" [(ngModel)]="newReport.version" placeholder="Ex: 1"
            [disabled]="isCreatingReport"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed">
        </div>

        <!-- Champ Document -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            {{ t('studyBet.modal.documentLabel') }} <span class="text-red-500">*</span>
          </label>
          <div class="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center"
            [class.bg-gray-50]="isCreatingReport">
            <input type="file" id="reportFileInput" (change)="onReportFileSelected($event)"
              accept=".pdf,.doc,.docx,.xls,.xlsx" [disabled]="isCreatingReport" class="hidden">

            <label for="reportFileInput" [class.cursor-not-allowed]="isCreatingReport"
              [class.opacity-50]="isCreatingReport"
              class="inline-flex items-center px-4 py-2 bg-orange-100 text-orange-600 rounded-lg cursor-pointer hover:bg-orange-200 transition-colors">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
              </svg>
              {{ t('common.chooseFile') }}
            </label>

            <div class="mt-2 text-sm" [class.text-gray-500]="!hasReportFileSelected()"
              [class.text-gray-700]="hasReportFileSelected()">
              {{ getReportFileName() }}
            </div>

            <p class="mt-2 text-xs text-gray-500">
              {{ t('studyBet.modal.acceptedFormats') }}
            </p>
          </div>
        </div>
      </div>

      <!-- Message d'erreur -->
      <div *ngIf="createReportError"
        class="mt-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm flex items-start">
        <svg class="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"></path>
        </svg>
        <span>{{ createReportError }}</span>
      </div>

      <!-- Boutons d'action -->
      <div class="flex gap-3 mt-6">
        <button (click)="createReport()" [disabled]="isCreatingReport "
          class="flex-1 px-4 py-2.5 text-white rounded-lg font-medium transition-opacity disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          style="background-color: #FF5C02;">
          <span *ngIf="!isCreatingReport">{{ t('common.send') }}</span>
          <span *ngIf="isCreatingReport" class="flex items-center">
            <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            {{ t('studyBet.modal.sending') }}
          </span>
        </button>
        <button (click)="cancelCreateReport()" [disabled]="isCreatingReport"
          class="flex-1 px-4 py-2.5 text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          {{ t('common.cancel') }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Rapport IA -->
<div *ngIf="showIAModal" class="fixed inset-0 z-[9999] overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen px-4">
    <div class="fixed inset-0 bg-black bg-opacity-60" (click)="closeIAModal()"></div>
    <div class="bg-white rounded-2xl shadow-2xl max-w-3xl w-full relative z-10 max-h-[90vh] overflow-y-auto">

      <!-- Header -->
      <div class="flex justify-between items-center px-6 py-4 border-b border-gray-100">
        <div class="flex items-center gap-3">
          <div class="w-9 h-9 bg-purple-100 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
            </svg>
          </div>
          <h2 class="text-lg font-semibold text-gray-900">{{ t('studyBet.ia.title') || 'Rapport IA' }} — {{ selectedEtudeForIA?.titre }}</h2>
        </div>
        <button (click)="closeIAModal()" class="text-gray-400 hover:text-gray-600">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      <!-- Loading -->
      <div *ngIf="isLoadingIA" class="flex flex-col items-center justify-center py-16">
        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-500 mb-4"></div>
        <p class="text-gray-500 text-sm">{{ t('studyBet.ia.loading') || 'Chargement du rapport IA...' }}</p>
      </div>

      <!-- Erreur -->
      <div *ngIf="!isLoadingIA && iaError" class="p-8 text-center">
        <div class="w-14 h-14 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        </div>
        <p class="text-gray-600 font-medium">{{ iaError }}</p>
        <p class="text-gray-400 text-sm mt-1">{{ t('studyBet.ia.errorRetry') || 'Veuillez réessayer ultérieurement.' }}</p>
      </div>

      <!-- Contenu du rapport IA -->
      <div *ngIf="!isLoadingIA && iaReport" class="p-6 space-y-5">

        <!-- En-tête infos : sévérité + type -->
        <div class="flex flex-wrap gap-3 items-center">
          <span [class]="'px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ' + getSeverityClass(iaReport.severity)">
            {{ t('studyBet.ia.severity') || 'Sévérité' }} : {{ getSeverityLabel(iaReport.severity) }}
          </span>
          <span class="px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            {{ getStudyTypeLabel(iaReport.studyType) }}
          </span>
        </div>

        <!-- Description -->
        <div class="bg-gray-50 rounded-lg p-4">
          <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">{{ t('common.description') || 'Description' }}</p>
          <p class="text-sm text-gray-700 leading-relaxed">{{ iaReport.description }}</p>
        </div>

        <!-- Observations -->
        <div class="border border-blue-100 rounded-lg p-4">
          <p class="text-xs font-semibold text-blue-600 uppercase tracking-wide mb-2 flex items-center gap-1">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7"/></svg>
            {{ t('studyBet.ia.observations') || 'Observations' }}
          </p>
          <div class="text-sm text-gray-700 leading-relaxed prose prose-sm max-w-none ia-html-content"
            [innerHTML]="getIAText(iaReport.observations)">
          </div>
        </div>

        <!-- Recommandations -->
        <div class="border border-green-100 rounded-lg p-4">
          <p class="text-xs font-semibold text-green-600 uppercase tracking-wide mb-2 flex items-center gap-1">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            {{ t('studyBet.ia.recommendations') || 'Recommandations' }}
          </p>
          <div class="text-sm text-gray-700 leading-relaxed prose prose-sm max-w-none ia-html-content"
            [innerHTML]="getIAText(iaReport.recommendations)">
          </div>
        </div>

        <!-- Conclusion -->
        <div class="border border-orange-100 rounded-lg p-4">
          <p class="text-xs font-semibold text-orange-600 uppercase tracking-wide mb-2 flex items-center gap-1">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
            {{ t('studyBet.ia.conclusion') || 'Conclusion' }}
          </p>
          <div class="text-sm text-gray-700 leading-relaxed prose prose-sm max-w-none ia-html-content"
            [innerHTML]="getIAText(iaReport.conclusion)">
          </div>
        </div>

        <!-- Documents / Images IA -->
        <div *ngIf="iaReport.documents && iaReport.documents.length > 0">
          <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">{{ t('studyBet.ia.analyzedDocs') || 'Documents analysés' }}</p>
          <div class="grid grid-cols-2 sm:grid-cols-3 gap-3">
            <div *ngFor="let docUrl of iaReport.documents" class="rounded-lg overflow-hidden border border-gray-200 bg-gray-50 aspect-video flex items-center justify-center">
              <img [src]="docUrl" [alt]="t('studyBet.ia.document') || 'Document IA'" class="w-full h-full object-cover" (error)="$any($event.target).style.display='none'">
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="flex justify-end pt-2 border-t border-gray-100">
          <button (click)="closeIAModal()" class="px-6 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 font-medium transition-colors">
            {{ t('common.close') || 'Fermer' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>